export const theme = {
    font: {
        heading: 'Ringside',
        paragraph: 'RingsideNarrow',
    },
    color: {
        primary: '#4d3849',
        primaryLight: '#a35470',
        secondary: '#ddc8ce',
        white: '#f3f3f3',
        black: '#222',
        darkgrey: '#444',
        grey: '#999',
        lightgrey: '#cdd',
        success: '#5e9b8b',
        info: '#49a0d9',
        warning: '#ffa872',
        danger: '#c16a5d',
    },
    border: {
        radius: '3px',
        width: '1px',
    },
    spacing: {
        extraSmall: '0.25rem',
        small: '0.5rem',
        medium: '1rem',
        large: '2rem',
        extraLarge: '4rem',
    },
    debug: `
        border: 1px solid #f99;
        * { border: 1px solid #f99; }
    `
}
